import * as React from 'react';
import { useFrameHooks } from '@xingternal/hub';
/**
 * Similar to the Feature Switch, with this, you can show different
 * elements bsed on the test case
 */
export const SplitKitSwitch = ({ experiment, cases, }) => {
    const { useExperiment } = useFrameHooks();
    const testCase = useExperiment(experiment);
    return React.createElement(React.Fragment, null, cases[testCase]);
};
//# sourceMappingURL=splitkit-switch.js.map